import { ConsumerBankAccountState, ConsumerBankAccountStatus, ConsumerBankAccountUse, FetchState, ConsumerBankAccountsResponse } from "@/shared/types";
import * as storeHelper from "@/shared/storeHelper";
import { defineStore } from "pinia";
import _ from "lodash";
import * as expenseService from "@/shared/api/expenseService";

export const initialState: ConsumerBankAccountState = {
    fetchState: FetchState.Uninitialized,
    consumerBankAccounts: [],
};

export const useConsumerBankAccountStore = defineStore("consumerBankAccount", {
    state: (): ConsumerBankAccountState => (_.cloneDeep(initialState)),
    getters: {
        isLoaded: state => state.fetchState === FetchState.Loaded,
        isLoading: state => state.fetchState === FetchState.Loading,
        getDirectDepositAccount: state => {
          return  _.find(state.consumerBankAccounts, c => {

                return c.bankAccountUse === ConsumerBankAccountUse.DirectDeposit
                && c.bankAccount.bankAccountStatus === ConsumerBankAccountStatus.Active;

            });
        }
    },
    actions: {
        loadBankAccounts (): Promise<ConsumerBankAccountsResponse[]> {

            if (this.fetchState === FetchState.Loaded) {
                return Promise.resolve(this.consumerBankAccounts);
            }

            this.fetchState = FetchState.Loading;
            return expenseService.getConsumerBankAccounts().then(response => {
                this.consumerBankAccounts = response.data;
                this.fetchState = FetchState.Loaded;
                return response.data;
            }).catch(err => storeHelper.handleError({ error: err, rethrow: true }));
        }
    }
});
